<sb-dialog-tab-list
  class="w-36 overflow-y-auto p-2"
  [tabs]="tabs"
  [selectedTab]="selectedTab"
  (selected)="selectTab($event)"
/>
<div #tabContentContainer class="flex-1 overflow-y-auto pr-2">
  <ng-content />
</div>
